export const formatDateWithTimezone = (
  date: string | Date,
  timezone: string | undefined,
  formatter: 'short' | 'long' = 'short'
): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(dateObj.getTime())) {
    return '';
  }

  const targetTimezone = timezone || 'UTC';
  const formatOptions: Intl.DateTimeFormatOptions = {
    timeZone: targetTimezone,
    year: 'numeric',
    month: formatter === 'short' ? '2-digit' : 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };

  const parts = new Intl.DateTimeFormat('en-US', formatOptions).formatToParts(dateObj);
  const dateParts: Record<string, string> = {};

  parts.forEach(part => {
    if (part.type !== 'literal') {
      dateParts[part.type] = part.value;
    }
  });

  const day = dateParts.day?.padStart(2, '0');
  const month = dateParts.month?.padStart(2, '0');
  const year = dateParts.year;
  const hour = dateParts.hour?.padStart(2, '0');
  const minute = dateParts.minute?.padStart(2, '0');
  const second = dateParts.second?.padStart(2, '0');

  if (!day || !month || !year || !hour || !minute || !second) {
    return new Intl.DateTimeFormat('en-GB', formatOptions).format(dateObj);
  }

  const time = `${hour}:${minute}:${second}`;

  if (formatter === 'short') {
    return `${day}/${month}/${year} ${time}`;
  }

  return `${day} ${month} ${year} ${time}`;
};
